import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class PlatformManagement extends Component {
  static propTypes = {
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    iconColor: PropTypes.string
  };

  static defaultProps = {
    width: 22,
    height: undefined,
    iconColor: '#000'
  };

  render() {
    const { height, width, iconColor } = this.props;

    const style1 = {
      fill: 'none',
      stroke: iconColor,
      strokeWidth: '3',
      strokeLinejoin: 'round',
      strokeMiterlimit: '10'
    };

    const style2 = {
      fill: 'none',
      stroke: iconColor,
      strokeWidth: '3',
      strokeMiterlimit: '10'
    };

    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 64 64"
        height={height}
        width={width}
      >
        <g id="Layer_1">
          <g>
            <polyline
              style={style1}
              points="52,41.1 53.2,37.5 61.9,37.5 61.9,25.9 53.2,25.9 51.3,20.2 57.1,14.4 49.3,6.7 43.6,12.5 
              37.8,10.5 37.8,1.9 32,1.9 26.2,1.9 26.2,10.5 20.4,12.5 14.7,6.7 6.9,14.4 12.7,20.2 10.8,25.9 2.1,25.9 2.1,37.5 10.8,37.5 
              12.7,43.3 6.9,49.1 14.7,56.8 20.4,51 26.2,52.9 26.2,61.6 32,61.6 34.3,61.6 		"
            />
            <circle style={style1} cx="32" cy="31.7" r="5.8" />
          </g>
        </g>
        <g id="Layer_2">
          <path
            fill={iconColor}
            d="M53.4,48.6l-8.8,8.5l-5.5-5.7c-0.2-0.3-0.6-0.3-0.9,0c-0.3,0.2-0.3,0.6,0,0.9l5.9,6.2c0.1,0.1,0.3,0.2,0.5,0.2
            c0.2,0,0.3-0.1,0.4-0.2l9.3-8.9c0.3-0.2,0.3-0.6,0-0.9C54.1,48.4,53.7,48.3,53.4,48.6z"
          />
          <rect x="34.4" y="41.4" style={style1} width="28.9" height="21.8" />
          <line style={style2} x1="34.4" y1="45" x2="63.3" y2="45" />
        </g>
      </svg>
    );
  }
}
